export default __webpack_public_path__ + "static/scARf2-a003f8394d0f51d47cfac6c4f2626868.png";